import React from "react";
import { InputNumber } from "antd";
import "./InputUsd.scss";

const InputUsd = (props : any) => (
  <InputNumber
    addonBefore={<>U$D</>}
    min={1}
    controls={false}
    className="input-number-usd"
    parser={value => {
      if (!value) return '';
      // Replace commas with dots, remove invalid chars, allow only one dot
      let parsed = value.replace(/,/g, '.').replace(/[^\d.]/g, '').replace(/\.(?=.*\.)/g, '');
      // Limit to two decimal places
      if (parsed.includes('.')) {
        const [intPart, decPart] = parsed.split('.');
        return intPart + '.' + decPart.slice(0, 2);
      }
      return parsed;
    }}
    decimalSeparator="."
    max={1000000000}
    {...props}
  />
);

export default InputUsd;
